import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          fontFamily: 'sans-serif',
          maxWidth: '800px',
          margin: '50px auto',
          backgroundColor: '#fee',
          border: '1px solid #fcc',
          borderRadius: '8px'
        }}>
          <h1 style={{ color: '#c33' }}>⚠️ Application Error</h1>
          <p>The application encountered an error and couldn't continue.</p>
          
          {this.state.error && (
            <div style={{ 
              backgroundColor: '#fdd', 
              padding: '10px', 
              borderRadius: '4px',
              marginTop: '10px',
              fontFamily: 'monospace',
              fontSize: '14px'
            }}>
              <strong>Error:</strong> {this.state.error.toString()}
            </div>
          )}
          
          {this.state.errorInfo && (
            <details style={{ marginTop: '10px', fontSize: '12px' }}>
              <summary style={{ cursor: 'pointer', marginBottom: '5px' }}>
                Component Stack Trace
              </summary>
              <pre style={{ 
                backgroundColor: '#fdd', 
                padding: '10px', 
                overflow: 'auto',
                fontSize: '11px',
                maxHeight: '300px'
              }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          
          <button 
            onClick={() => window.location.reload()} 
            style={{
              marginTop: '15px',
              padding: '8px 16px',
              backgroundColor: '#c33',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
